import {
  inline,
} from "CommonState/action-helpers";

export function toggleDashboardMenu() {
  return inline("dashboardMenuCollapsed", state => state.dashboardMenuCollapsed = !state.dashboardMenuCollapsed);
}

export function setFlag(name, value) {
  // Beliebigen Flag (einfache Datentypen) mit Wert belegen über den Store verfügbar mnachen
  return inline("flag_" + name, state => state["flag_" + name] = value);
}

export function toggleFlag(name) {
  //  (Boolean) Flag umschalten
  return inline("flag_" + name, state => state["flag_" + name] = !state["flag_" + name]);
}

